import { useMutation } from '@apollo/client';
import {
  ISlackOAuthStartMutation,
  ISlackOAuthStartMutationVariables,
} from '../../utils/apollo/graphqlSchema';
import printGraphqlErrors from '../../utils/apollo/printGraphqlErrors';
import { useCallback } from 'react';
import { SLACK_OAUTH_START } from '../../utils/apollo/slack/mutations';
import { slackIntegrationConnected } from '../../utils/analytics/events/slack/events';
import { useAnalytics } from '../../utils/analytics/useAnalytics';

const useSlackOAuthStart = () => {
  const { track } = useAnalytics();

  const [executeSlackOAuthCallback, { loading }] = useMutation<
    ISlackOAuthStartMutation,
    ISlackOAuthStartMutationVariables
  >(SLACK_OAUTH_START);

  const startSlackOAuth = useCallback(async () => {
    const response = await executeSlackOAuthCallback();
    const result = response?.data?.slackOAuthStart;
    if (printGraphqlErrors(result?.errors)) {
      return null;
    }
    track(slackIntegrationConnected());
    return result?.entity?.authorizeUrl ?? null;
  }, [executeSlackOAuthCallback, track]);

  return { startSlackOAuth, startSlackOAuthLoading: loading };
};

export default useSlackOAuthStart;
